/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ORDER_BY_ENUM;
(function (ORDER_BY_ENUM) {
    ORDER_BY_ENUM["ASC"] = "ASC";
    ORDER_BY_ENUM["DESC"] = "DESC";
})(ORDER_BY_ENUM || (ORDER_BY_ENUM = {}));
